import { gql, useLazyQuery } from '@apollo/client';
import { AnyObject } from '../../models/types';

interface IntegrationVars {
  accountId: string;
  datasourceName: string | null;
}

const GQL_INTEGRATION = gql`
  query getIntegration($accountId: String!, $datasourceName: String) {
    integration(accountId: $accountId, datasourceName: $datasourceName)
  }
`;

export const useIntegrationQuery = () => {
  return useLazyQuery<AnyObject, IntegrationVars>(GQL_INTEGRATION, {
    errorPolicy: 'all',
    fetchPolicy: 'no-cache'
  });
};
